// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"1198":"menu-js","3090":"js-video-testimonial","3519":"video-playlist","4129":"hovernavigation","5839":"manual-news","8093":"table-of-content"}[chunkId] || chunkId) + ".css";
};